<template>
  <app-modal
    :modal-id="modalId"
    :title="modalTitle"
    :preloader="preloader"
    @submit="submit"
    @close-modal="closeModal"
    modal-size="extra-large"
  >
    <template slot="body">
      <app-overlay-loader v-if="preloader" />
      <form
        class="mb-0"
        :class="{ 'loading-opacity': preloader }"
        ref="form"
        :data-url="
          selectedUrl
            ? `/accreditationreview/accreditations/processAcusseReceipt/${inputs.id}`
            : `/accreditationreview/accreditations/processAcusseReceipt/`
        "
      >
        <legend>
          <p class="text-primary">Documentos anteriores</p>
        </legend>
        <div class="row">
          <div class="col-12">
            <table class="table table-sm table-striped">
              <thead>
                <tr>
                  <th scope="col">NOMBRE</th>
                  <th scope="col" class="text-center">FECHA CREACIÓN</th>
                  <th scope="col">USUARIO</th>
                  <th scope="col" class="text-center">ACCIÓN</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, key) in inputs.files" :key="key">
                  <td class="align-middle">
                    Registro de Ingreso de solicitud de acreditación y Acuse
                    Recibo {{ key + 1 }}
                    <span
                      class="badge badge-sm badge-pill badge-danger"
                      v-if="item.type == lastPosition.type"
                      >Último registrado</span
                    >
                  </td>
                  <td class="align-middle">
                    {{ item.created_at | dateFormat }}
                  </td>
                  <td class="align-middle">
                    {{ technical }}
                  </td>
                  <td class="align-middle text-center">
                    <button
                      type="submit"
                      class="btn btn-success"
                      @click.prevent="openTab(item)"
                    >
                      <app-icon name="file" />
                      {{ $t("view") }}
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <div class="form-group row align-items-center">
          <label for="inputs_name" class="col-sm-3 mb-0">
            {{ $t("Es correcta la revisión del gestor técnico de expediente?") }}
          </label>
          <app-input
            id="inputs_name"
            class="col-sm-9"
            type="radio-buttons"
            v-model="inputs.accept_acusse_receipt"
            :list="list"
          />
        </div>

        <div
          class="form-group"
          v-if="!inputs.accept_acusse_receipt"
        >
          <label for="inputs_name">
            {{ $t("Observaciones") }}
          </label>
          <app-input
            id="inputs_name"
            type="textarea"
            v-model="inputs.observations"
          />
        </div>
        <hr v-if="inputs.accept_acusse_receipt == 1" />
        <div
          class="form-group row align-items-center"
          v-if="inputs.accept_acusse_receipt == 1"
        >
          <label for="inputs_name" class="col-sm-3 mb-0">
            {{ $t("¿Se acepta la solicitud de acreditación?") }}
          </label>
          <app-input
            id="inputs_name"
            class="col-sm-9"
            type="radio-buttons"
            v-model="is_approved"
            :list="list"
          />
        </div>
        <div class="form-group" v-if="(inputs.reject_counter == 1 && is_approved == 0)">
          <label>{{ $t("Observaciones") }}</label>
          <app-input
            id="inputs_name"
            type="textarea"
            v-model="inputs.observations"
          />
          <p class="text-danger">Recuerde que si no aprueba la solicitud, se anulará.</p>
        </div>

        <div class="form-group" v-if="( is_approved == 0 && inputs.reject_counter == 0 && inputs.accept_acusse_receipt==1)">
          <label>{{ $t("Seleccione una opción") }}</label>
          <app-input
            id="inputs_opt"
            type="select"
            v-model="optionSelected"
            :list="list2"
          />
        </div>

        <!-- <div
          class="form-group row align-items-center"
          
        >
          <label for="inputs_name" class="col-sm-3 mb-0">
            {{ $t("Observaciones") }}
          </label>
          <app-input
            id="inputs_name"
            class="col-sm-9"
            type="textarea"
            v-model="inputs.observations"
          />
        </div> -->
      </form>
    </template>
    <template slot="footer">
      <button
        type="button"
        class="btn btn-secondary mr-2"
        data-dismiss="modal"
        @click="closeModal"
      >
        Cerrar
      </button>
      <button type="submit" class="btn btn-primary" @click.prevent="submit">
        Guardar
      </button>
    </template>
  </app-modal>
</template>

<script>
import { FormMixin } from "@/core/mixins/form/FormMixin.js";
import { ModalMixin } from "@/app/Mixins/ModalMixin";

export default {
  name: "ApplicacionAddModal",
  mixins: [FormMixin, ModalMixin],
  props: {
    tableId: String,
    accreditationEmployeList: Array,
  },

  filters: {
    dateFormat: function (value) {
      return moment(value).format("YYYY-MM-DD HH:mm");
    },
  },

  data() {
    return {
      preloader: false,
      inputs: {},
      modalId: "asign-add-edit-modal",
      modalTitle: this.$t("Add"),
      files: "",
      technical: "",
      lastPosition: "",
      showValid: false,
      is_satisfactory: "",
      is_approved: 1,
      director: "",
      optionSelected:0,
      list: [
        {
          id: 1,
          value: "SI",
        },
        {
          id: 0,
          value: "NO",
        },
      ],
      list2: [
        {
          id: 2,
          value: "Enviar al OEC la comunicación de que SAE debe desarrollar un nuevo esquema.",
        },
        {
          id: 1,
          value: "Enviar al OEC la comunicación de que SAE debe ubicar y calificar a un experto nuevo.",
        },
        {
          id: 0,
          value: "Enviar al OEC para que complete o adecue la información de la solicitud de acreditación y/o anexos.",
        },
      ],
    };
  },

  created() {
    if (this.selectedUrl) {
      this.modalTitle = this.$t(
        "Revisión y aceptación de Registro de Ingreso de solicitud de acreditación y Acuse Recibo"
      );
      this.preloader = true;
    }
  },
  methods: {
    submit() {
      var data = {};
      data["id"] = this.inputs.id;
      data["is_satisfactory"] = this.inputs.accept_acusse_receipt;
      data["is_approved"] = this.is_approved;
      data["optionSelected"] = this.optionSelected;
      if (this.inputs.observations) {
        data["observations"] = this.inputs.observations;
      }
      this.save(data);
    },

    openTab(item) {
      const w = window.open(item.path, "_blank");
      w.focus();
    },

    afterSuccess() {
      this.$toastr.s("Actualizado exitosamente");
      this.$hub.$emit("reload-" + this.tableId);
    },

    afterSuccessFromGetEditData(response) {
      this.inputs = response.data;
      this.inputs.files = response.data.receipt_return_report_no_signed;
      this.lastPosition =
        response.data.receipt_return_report_no_signed[
          response.data.receipt_return_report_no_signed.length - 1
        ];
      this.technical = response.data.technical.full_name;
      if (this.inputs.accept_acusse_receipt == 0) {
        this.showValid = false;
      } else {
        this.showValid = true;
      }
      this.preloader = false;
    },
  },
};
</script>